import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, useConfig, useTranslations } from "@jti/ui";
import ArrowRightButton from "@jti/ui/icons/arrow-right-button.svg";
import styles from "./OrderSummaryRedirectToOrder.module.scss";
export const OrderSummaryRedirectToOrder = ({ orderId, isFreeTrial }) => {
    const { __ } = useTranslations();
    const { PROFILE_PAGE_URL } = useConfig();
    if (!orderId) {
        return null;
    }
    const linkHref = `${PROFILE_PAGE_URL}#/${isFreeTrial ? "trial" : "orders"}/${orderId}`;
    return (_jsxs("div", { className: styles.orderSummaryRedirectToOrder, children: [_jsx("span", { className: styles.text, children: __("cart.order.summary.summaryLink", [orderId]) }), _jsx("a", { className: styles.link, href: linkHref, children: _jsx(Icon, { className: styles.icon, component: ArrowRightButton, width: "32px", height: "22px", restSvgProps: { viewBox: "0 0 34 22" } }) })] }));
};
//# sourceMappingURL=OrderSummaryRedirectToOrder.js.map